import { Container } from 'inversify'
import { ref } from 'vue'

import * as app from '@mobile/globalState/app'
import { EventSettings } from '@mobile/reusables/types/EventSettings'
import { RelationIoCBindings } from '@mobile/views/Relation/Shared/RelationDependencies/types'

import { CricketRelationIoCBindings } from './CricketRelationDependencies'

export function bindEventSettings(ioc: Container): void {
  const eventSettings = ref<EventSettings>({})

  ioc
    .bind(CricketRelationIoCBindings.EventSettings)
    .toConstantValue(eventSettings)
    .onActivation(async (ctx, eventSettingsRef) => {
      const probableEvent = await ctx.container.getAsync(
        RelationIoCBindings.ProbableEvent,
      )
      const eventSettingsRecord =
        await app.state.database.eventSettingsRepository.getByEventId(
          probableEvent.value.id,
        )

      eventSettingsRef.value = eventSettingsRecord?.settings ?? {}

      return eventSettingsRef
    })
}
